<style>
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
a {
  color: #333333;
  text-decoration: none;
}
a:hover {
  color: #1890ff;
  text-decoration: none;
}
.hdNews {
  padding: 12px 24px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.content_body li {
  line-height: 28px;
  padding: 0 0 0 10px;
}
.clear {
  clear: both;
}
</style>
<template>
  <div>
    <HeaderView></HeaderView>
    <NavigateView></NavigateView>
    <BannerView></BannerView>
    <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;">
      <template>
        <div class="content_body">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item style="padding-top: 8px;">集中议价</el-breadcrumb-item>
            <el-breadcrumb-item style="padding-top: 8px;">关注问题</el-breadcrumb-item>
            <!-- <el-button key="点我留言" size="mini" style="float: right;" @click="question">点我留言</el-button> -->
          </el-breadcrumb>
          <el-divider content-position="left"></el-divider>
          <div v-if="showLink">
            <div>&emsp;&emsp;</div>
            <div>&emsp;&emsp;<el-link type="primary" @click="changeContent(1)"  style="font-size: 14px; margin-bottom: 10px;">1、有关企业关注的药品集中议价若干问题</el-link></div>
            <div>&emsp;&emsp;<el-link type="primary" @click="changeContent(2)"  style="font-size: 14px; margin-bottom: 10px;">2、上海公立医疗机构（部分）药品集中议价采购联盟实施工作相关事项告知</el-link></div>
            <div>&emsp;&emsp;<el-link type="primary" @click="changeContent(3)"  style="font-size: 14px; margin-bottom: 10px;">3、议价工作通知</el-link></div>
            <div>&emsp;&emsp;<el-link type="primary" @click="changeContent(4)"  style="font-size: 14px; margin-bottom: 10px;">4、有关推荐药品配送企业的说明</el-link></div>
            <div>&emsp;&emsp;<el-link type="primary" @click="changeContent(5)"  style="font-size: 14px; margin-bottom: 10px;">5、集中议价中选品种超红线的处理流程</el-link></div>
            <!-- <div>&emsp;&emsp;<el-link type="primary" @click="changeContent(4)">2、致药品生产企业的建议函</el-link></div> -->
            <div>&emsp;&emsp;</div>
          </div>
          <div v-if="showContent[1]">
            <div style="float: right;">
              <el-link icon="el-icon-close" @click="changeContent(0)">关闭</el-link>
            </div>
            <p style="text-align: center;font-size: 14px;font-family: 微软雅黑;">
              <span style="font-size: 24px;font-family: 微软雅黑;">有关企业关注的药品集中议价若干问题</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;">
              &nbsp;
            </p>
            <p style="font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <span style="line-height: 24px; font-family: 微软雅黑; font-size: 14px;">各有关药品生产（经营）企业：</span>
            </p>
            <p style="font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-family: 微软雅黑; font-size: 14px;">感谢您对上海公立医疗机构（部分）药品集中议价采购联盟药品集团采购和集中议价工作的支持和积极参与。</span>
            </p>
            <p style="font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-family: 微软雅黑; font-size: 14px;">按《上海公立医疗机构（部分）药品集中议价采购联盟药品集团采购和集中议价文件》（SHJZYJLM-JZYJ2021-1）中约定的工作流程，已由采购联盟医疗机构专家完成了临床专业评价,即将开展申报药品的遴选，拟定议价药品品种，分类分批与涉及的生产企业进行集中议价工作。</span>
            </p>
            <p style="font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-family: 微软雅黑; font-size: 14px;">采购联盟办公室根据申报企业前期集中反馈的问题，以问答形式做以下回复：</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">问题一：中选药品价格是否对外公开？</span></strong>
            </p>
            <p style="font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">按照《关于构建多方联动的药品集中采购格局鼓励和推进本市药品集中议价采购工作的试行意见》(沪医保价采〔2020〕77号）文件中有关“除监管部门外，集中议价中选药品价格，仅供参与集中议价采购的联盟医疗机构使用”的规定，相关政府管理部门不主动向社会公开集中议价中选药品价格，包括其它医疗机构和外省市。</span>
            </p>
            <p style="font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">按照《关于印发药品和医用耗材集中采购公共服务事项清单的通知》（医保价采中心发〔2021〕2号），形成的药品集中议价价格，经相关部门研究，视同为签订保密协议，不提供公众查询。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">问题二：非联盟会员医疗机构是否可以使用中选药品价格？</span></strong>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">本次集中议价中选药品价格，仅供参与集中议价采购的联盟医疗机构使用。除能提供同等或更优条件，中选生产企业可以拒绝非联盟医疗机构联动集中议价价格的要求。</span>
            </p>
            <p style="font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">上海市医药采购服务与监管信息系统（简称“阳光平台”）设置单独模块，仅供参与本次药品集中议价的联盟医疗机构使用。非联盟医疗机构在现有议价系统中，无法查询到本次集中议价中选药品价格。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">问题三：中选药品价格是否可在市内或外省市联动？</span></strong>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">本次集中议价中选药品价格不纳入本市阳光平台公开挂网议价的价格联动范围。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">除能提供同等或更优条件，不建议外省市联动本市药品集中议价价格。上海市医药集中招标采购事务管理所可为中选生产企业提供不建议联动本市药品集中议价价格的书面材料。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">对于本次药品集中议价中选药品，在采购周期内，联盟医疗机构承诺不主动联动新的全国最低价，政策因素或企业自愿除外。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">问题四：通常可以中选几家生产企业的药品？</span></strong>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">为保障临床供应，避免无序竞争，综合采购金额大小、竞争充分程度等因素，按“通用名+给药途径”确定本次药品集中议价中选药品的生产企业数，一般为2-4家。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">问题五：非中选药品是否可以继续在联盟医疗机构使用？</span></strong>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">联盟医疗机构优先在本次药品集中议价中选药品范围内进行采购，从严管理非中选药品在联盟医疗机构的使用，如确需使用，由参与联盟医疗机构药事会审议通过，继续通过本市药品采购阳光平台实施采购。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">问题六：是否开展日常监控联盟医疗机构药品？</span></strong>
            </p>
            <p style="font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">采购联盟办公室对集中议价中选药品/非中选药品采购情况进行数据监测，形成动态监测报告。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">问题七：结算时间有限制吗？</span></strong>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">联盟医疗机构的中选药品货款结清时间应明显优于本次集中议价采购实施前，及其它未中选药品，一般不超过交货验收合格后次月底。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">问题八：有建议的议价降幅吗？</span></strong>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">综合集中议价规模、使用保证、货款支付、降低药品营销区间成本等的因素，原则上，所有参与本次药品集中议价的药品价格均应低于医疗机构挂网公开议价采购价格。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">本次药品集中议价根据药品特性、拟中选药品的企业数、申报价格等，形成价格淘汰线，在综合评价的基础上，确定拟中选药品。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">无临床专家评价投票、无医疗机构使用或无价格降幅的药品，原则上不予中选。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">问题九：议价通知的发放对象？</span></strong>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">议价谈判工作将根据专家遴选进度分类分批逐步进行，对经综合评价确定的拟入围药品所涉及的生产企业，将发出议价通知。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">&nbsp;</span>
            </p>
            <p style="text-align: center; font-size: 14px; font-family: 微软雅黑; ; text-indent: 32px; line-height: 21px;">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="font-family: 微软雅黑; text-align: right;">上海公立医疗机构（部分）药品集中议价采购联盟办公室</span>
            </p>
            <p style="font-size: 14px; font-family: 微软雅黑; ; text-indent: 32px; line-height: 21px;">
              <span style="text-align: right; line-height: 24px; font-family: 微软雅黑;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2021年9月18日&nbsp;</span><span style="text-align: right; font-size: 14px; line-height: 24px; font-family: 微软雅黑;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">&nbsp;</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">&nbsp;</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 43px">
              <span style="font-size: 21px">&nbsp;</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 43px">
              <span style="font-size: 21px">&nbsp;</span>
            </p>
            <p>
              <br />
            </p>
          </div>
          <div v-if="showContent[2]">
            <div style="float: right;">
              <el-link icon="el-icon-close" @click="changeContent(0)">关闭</el-link>
            </div>
            <p style="text-align: center;">
                <span style="font-size: 24px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">上海公立医疗机构（部分）药品集中议价采购联盟</span>
            </p>
            <p style="text-align: center;">
                <span style="font-size: 24px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">实施工作相关事项告知</span>
            </p>
            <p>
                <br/>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&emsp;&emsp;根据《关于构建多方联动的药品集中采购格局 鼓励和推进本市药品集中议价采购工作的试行意见》(沪医保价采[2020]77号）的文件精神，及上海公立医疗机构（部分）药品集中议价采购联盟药品集团采购和集中议价公告（SHJZYJLM-JZYJ2021-1）及议价文件相关要求，集中议价药品中选通知已分批发出，根据采购联盟医疗机构、生产企业、经营企业的反馈，有关实施工作事项告知如下：</span>
            </p>
            <p>
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px;">1.中选药品目录</span></strong>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">集中议价的中选药品已通过邮件分别发送至各中选生产企业，未收到邮件通知则为议价尚未成功，企业如仍有意愿意愿继续参与，可通过邮件继续进行议价。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">集中议价中选药品目录也已发送至各采购联盟医疗机构，供各医疗机构进行匹配勾选。</span>
            </p>
            <p>
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px;">2.中选药品价格</span></strong>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">集中议价中选药品的集中议价价格通过阳光平台的单独模块进行维护。相关价格信息仅供参与本次药品集中议价的医疗机构使用。非联盟医疗机构在现有议价系统中，无法查询到本次集中议价中选药品价格。中选生产企业可以拒绝非联盟医疗机构联动集中议价价格的要求。</span>
            </p>
            <p>
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px;">3.中选药品的配送</span></strong>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">集中议价中选药品由采购联盟医疗机构自行确定配送企业。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">集中议价中选药品生产企业需及时将本企业中选药品的集中议价价格以书面形式通知相关药品配送企业，由中选药品生产企业（或其代理商）与药品配送企业签订合同，确保在采购联盟内按集中议价中选价格执行。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">中选药品生产企业、相关药品配送企业共同做好中选药品在采购联盟医疗机构的供应保障工作，不因价格差异影响采购联盟单位的药品供应保障。</span>
            </p>
            <p>
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px;">4.中选药品采购生效</span></strong>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">采购联盟统一在阳光平台子模块完成采购联盟医疗机构及药品的信息维护工作。各采购联盟医疗机构按实际准备情况，确定实施启动日期，按集中议价价格通过阳光平台分批实施采购。</span>
            </p>
            <p>
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px;">5.中选药品实施过程的价格变动</span></strong>
            </p>
            <p>
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">（1）</span></strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">如遇国家及本市政策调整、国家（省）带量采购、医保谈判和定点生产等原因，集中议价中选药品按相关政策要求进行调整。</span>
            </p>
            <p>
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">（2）</span></strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">如遇本市阳光平台药品“红黄绿线”价格监测预警，集中议价中选药品的降幅原则上不变。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">降幅（%）=（调整前阳光平台医疗机构单独议价价格-企业集中议价采购价格）/调整前阳光平台医疗机构单独议价价格*100%</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">重新计算的集中议价采购价格=调整后的医疗机构单独议价价格*（100%-降幅）</span>
            </p>
            <p>
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">（3）</span></strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">根据第三方服务机构采集的集中议价价格变动情况，采购联盟工作组及时以价格确认函的形式通知所涉中选生产企业。生产企业应及时反馈价格确认意见，由工作组进行复议。其中，集中议价价格超红线的品种，生产企业须在5个工作日内予以反馈。</span>
            </p>
            <p>
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">（4）</span></strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">采购联盟定期（一般为3个月）发布集中议价中选药品的价格变动结果，医疗机构按采购联盟发布的有效价格执行。</span>
            </p>
            <p>
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px;">6.中选目录的调整</span></strong>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">采购联盟将根据集中议价中选目录与联盟医疗机构需求的匹配情况、及联盟医疗机构药品采供、临床使用中的反馈，对需要进行集中议价的品种，主动发起议价协商。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">中选药品目录将根据实施过程中的企业继续响应情况、价格动态调整情况等进行相应的增补、变更。中选药品目录调整信息通知相关生产企业、采购联盟医疗机构。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">新挂网的药品，生产企业可主动向采购联盟发起议价申请。</span>
            </p>
            <p>
                <br/><br/>
            </p>
            <p style="text-align: right;">
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">上海公立医疗机构（部分）药品集中议价采购联盟办公室</span></strong>
            </p>
            <p style="text-align: right;">
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp; 2022年9月1日&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></strong>
            </p>
            <p>
                <br/>
            </p>
            <p>
                <br/>
            </p>
          </div>
          <div v-if="showContent[3]">
            <div style="float: right;">
              <el-link icon="el-icon-close" @click="changeContent(0)">关闭</el-link>
            </div>
            <p style="text-align: center;">
                <span style="font-size: 24px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">议价工作通知</span>
            </p>
            <p>
                <br/>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px;">各药品生产企业：</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&emsp;&emsp;因本市阳光平台药品“红线”价格变动，部分药品集中议价中选品种的价格出现突破或等于红线的情况，按集中议价中选药品降幅原则上不变的要求，将就此类产品的议价价格与涉及企业再次确认。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&emsp;&emsp;另第七批国家组织药品集中采购结果已经公布，根据采购联盟工作要求，也将与涉及企业再次开展集中议价工作。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&emsp;&emsp;具体涉及品种将通过邮件的方式予以发送。</span>
            </p>
            <p>
                <br/><br/>
            </p>
            <p style="text-align: right;">
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">上海公立医疗机构（部分）药品集中议价采购联盟办公室</span></strong>
            </p>
            <p style="text-align: right;">
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp; 2022年11月18日&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></strong>
            </p>
            <p>
                <br/>
            </p>
            <p>
                <br/>
            </p>
          </div>
          <div v-if="showContent[4]">
            <div style="float: right;">
              <el-link icon="el-icon-close" @click="changeContent(0)">关闭</el-link>
            </div>
            <p style="text-align: center;">
                <span style="font-size: 24px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">有关推荐药品配送企业的说明</span>
            </p>
            <p>
                <br/>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px;">各集中议价中选药品生产企业：</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&emsp;&emsp;上海公立医疗机构（部分）药品集中议价采购联盟各医疗机构正在逐步启动采购工作，根据医疗机构反馈，为了更好地协助药品生产企业对接配送渠道，做好医疗机构的药品采购保障工作，采购联盟办公室在综合评估药品配送企业配送网络可及性、配送服务能力与质量等因素的基础上，与国药控股股份有限公司进行了沟通。国药控股股份有限公司表示，愿为相关药品生产企业提供通畅的配送渠道和优质的配送服务。各生产企业如有需要，可及时联系。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&emsp;&emsp;特告！</span>
            </p>
            <p>
                <br/><br/>
            </p>
            <p style="text-align: right;">
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">上海公立医疗机构（部分）药品集中议价采购联盟办公室</span></strong>
            </p>
            <p style="text-align: right;">
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp; 2022年12月09日&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></strong>
            </p>
            <p>
                <br/>
            </p>
            <p>
                <br/>
            </p>
          </div>
          <div v-if="showContent[5]">
            <div style="float: right;">
              <el-link icon="el-icon-close" @click="changeContent(0)">关闭</el-link>
            </div>
            <p style="text-align: center;">
                <span style="font-size: 24px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">集中议价中选品种超红线的处理流程</span>
            </p>
            <p>
                <br/>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&emsp;&emsp;本市阳光平台按议价规则进行“红黄绿线”动态调整后，集中议价中选品种如出现超红线的情况，处理流程如下：</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&emsp;&emsp;1.自集中议价中选目录移除。对超红线的集中议价中选品种，在阳光平台子模块中自动标记并移出中选目录。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&emsp;&emsp;2.议价发起原则。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&emsp;&emsp;（1）对超红线的集中议价中选品种，若中选目录中有同通用名的其他中选品种，原则上采购联盟不再主动发起议价。若生产企业有继续参与意愿，可主动提出议价报价。</span>
            </p>
            <p>
                <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&emsp;&emsp;（2）对超红线的集中议价中选品种，若中选目录中无同通用名的中选品种，采购联盟将主动发起议价，原则上企业应保持原降幅不变。为保证采购联盟医疗机构用药需求，经专家讨论，也可与该通用名下其他未中选厂家进行议价。</span>
            </p>
            <p>
                <br/><br/>
            </p>
            <p style="text-align: right;">
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">上海公立医疗机构（部分）药品集中议价采购联盟办公室</span></strong>
            </p>
            <p style="text-align: right;">
                <strong><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp; 2023年01月16日&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></strong>
            </p>
            <p>
                <br/>
            </p>
            <p>
                <br/>
            </p>
          </div>
          <div v-if="showContent[6]">
            <div style="float: right;">
              <el-link icon="el-icon-close" @click="changeContent(0)">关闭</el-link>
            </div>
            <p style="text-align: center;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 24px;">致药品生产企业的建议函</span>
            </p>
            <p style="text-align: center;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 24px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——关于共同推进药品集中议价工作</span>
            </p>
            <p>
              <br />
            </p>
            <p style="text-indent: 0em; line-height: 2em;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;"><strong>各药品生产企业：</strong></span>
            </p>
            <p style="text-indent: 0em; line-height: 2em;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp; &nbsp; &nbsp; 药品采供改革是推动三医联动改革、促进医药行业健康发展的重要举措，随着国家医改工作持续深化，与药品采供改革相关的两大趋势也日渐明确：一是在药品带量采购常态化、制度化推进，持续扩面的形势下，构建新的药品采供体系框架的工作思路已经形成。二是以DRG/DIP为主导的医保支付制度改革已全面铺开，进入实际支付阶段。在这样的趋势下，主动降低药品采购等的运营成本，主动从重收入向降成本的运行机制转变成为医疗机构的必由之路。</span>
            </p>
            <p style="text-indent: 0em; line-height: 2em;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp; &nbsp; &nbsp; 在上海市医改办、上海市医疗机构药品集中招标采购协调管理委员会的推动下，市医保局和市卫生健康委于2020年7月，联合印发了《关于构建多方联动的药品集中采购格局 鼓励和推进本市药品集中议价采购工作的试行意见》(沪医保价采[2020]77号），鼓励探索开展药品集中议价采购，将药品集中议价采购工作纳入全市医药招采制度整体框架，作为药品供应保障体系的重要组成部分。</span>
            </p>
            <p style="text-indent: 0em; line-height: 2em;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp; &nbsp; &nbsp; 原上海公立医疗机构药品集团采购联盟在药品集团采购（GPO）试点的基础上，按照文件精神，积极向集中议价工作方向进行转变，扩充参与单位，组成了上海公立医疗机构（部分）药品集中议价采购联盟（以下简称“采购联盟”），探索落实集中议价工作。采购联盟委托上海医健卫生事务服务中心作为第三方服务机构提供事务和技术支持服务。</span>
            </p>
            <p style="text-indent: 0em; line-height: 2em;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp; &nbsp; &nbsp; 集中议价的本质是将采购联盟医疗机构的用药需求进行汇总合并，予以公开，经采购联盟专家组的集中遴选和议价后，形成采购联盟医疗机构共同的药品采购目录。联盟医疗机构优先在该目录内进行采购，从严管理非中选药品在医疗机构的使用，如确需使用，须由医疗机构药事会审议通过。这一举措将大大降低医疗机构和药品生产企业之间的流通成本，同时对规范医疗机构药品使用，提高各级医疗机构用药层次和质量，降低医疗机构运营成本，都将产生积极意义。</span>
            </p>
            <p style="text-indent: 0em; line-height: 2em;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp; &nbsp; &nbsp; 药品集中议价是通过市场议价的机制，由购销双方根据市场供求原则，互动协商确定药品采购价格。但由于目前药品采供改革处在交替过渡阶段，新老药品采供体系转轨尚未完成，药品集中议价作为试点探索，首先要着力营造符合“量价挂钩”市场规则的氛围，形成集中议价价格应低于医疗机构单独议价价格的共识。</span>
            </p>
            <p style="text-indent: 0em; line-height: 2em;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp; &nbsp; &nbsp; 为了保证试点工作顺利推进，根据企业反映的“底价联动”等问题，相关部门进行了认真地集中研究，围绕不合理的价格联动所产生的负面效应出台了多项具体措施，推动形成更为科学的“量—价”对应、梯度降价的市场规则。</span>
            </p>
            <p style="text-indent: 0em; line-height: 2em;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp; &nbsp; &nbsp; 目前，采购联盟药品集中议价工作正在逐批开展，联盟办公室认为有必要与各参与本次集中议价药品生产企业的市场营销决策部门进行信息交流和沟通，积极响应，分享经验，参与集中议价的试点工作，共同营造符合市场规则的药品价格体系。</span>
            </p>
            <p>
              <br /><br />
            </p>
            <p dir="rtl" style="text-align: justify; text-indent: 0em; line-height: 2em;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">上海公立医疗机构（部分）药品集中议价采购联盟办公室</span>
            </p>
            <p dir="rtl" style="text-align: justify; text-indent: 0em; line-height: 2em;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上海医健卫生事务服务中心</span>
            </p>
            <p dir="rtl" style="text-align: justify; text-indent: 0em; line-height: 2em;">
              <span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2021年12月6日</span>
            </p>
            <p>
              <br />
            </p>
            <p>
              <br />
            </p>
          </div>
        </div>

      </template>
    </div>

    <FooterView></FooterView>
  </div>

</template>
<script>
export default {
  name: 'concernedAbout',
  data () {
    return {
      active: 0,
      height: 0,
      operate: false,
      captchaUrl: '',
      display: false,
      showLink: false,
      showContent: [false, false, false, false, false, false],
      dialogVisible: false,
      dialogApplyVisible: false,
      submitButtonLoading: false,
      form: { ctgId: '', title: '', content: '', captcha: '', positions: '', phone: '', email: '', participants: '', },

      queryform: {
        data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50, 100], fn: 'page',
      },
      categoryList: [],
      liBackgroundImg: process.env.VUE_APP_API_URL + 'r/cms/www/default/img/index/li_bg.jpg',
    };
  },
  mounted () {
    if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.height = document.documentElement.clientHeight - 350;
    //监听浏览器窗口变化　
    window.onresize = () => { this.height = document.documentElement.clientHeight - 350 }
  },
  created () {
    this.initView()
  },
  watch: {},
  methods: {
    initView () {
      setTimeout(() => {
        this.submitButtonLoading = true;
        new Promise((resolve, reject) => {
          return this.$api.memberApi.getDeclareResult({ stype: 'DECLARE' }).then(data => {
            if (!data) {
              this.goLogin();
            } else {
              if (200 === data.status) {
                if (200 === data.data.code) {
                  this.showLink = true
                } else if (403 === 200) {
                  this.showLink = false
                } else {
                  this.showLink = false
                }
              } else {
                this.goLogin();
              }
            }
            resolve(true);
          })
        }).catch(err => {
          this.goLogin();
        })
      })
    },
    handleClick (tab, event) {
      if (this[event]) {
        this[event].call(this, tab);
      }
    },
    changeContent (idx) {
      if (idx) {
        this.showLink = false;
        this.showContent.forEach((w, index) => {
          if (index === idx) {
            this.showContent[index] = true;
          } else {
            this.showContent[index] = false;
          }
        })
      } else {
        this.showContent.forEach((w, index) => {
          this.showContent[index] = false;
        })
        this.showLink = true;
      }
      console.info(this.showContent)
    },
    getRowKeys (row) {
      return row.id
    },
    toDateString: function (time, format) {
      let date = new Date(time || new Date())
        , ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        , hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
      format = format || 'yyyy-MM-dd HH:mm:ss';
      return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
    },
    clearValidate (formName) {
      this.$refs[formName].clearValidate();
    },
    changeCaptcha: function () {
      this.captchaUrl = this.getCaptchaUrl();
    },
    getCaptchaUrl: function () {
      this.form.captcha = '';
      return process.env.VUE_APP_API_URL + 'captcha.svl?d=' + new Date().getTime()
    },
    goLogin () {
      this.$message({ message: '登录过期，请重新登录账户！', offset: 200, type: 'error' });
      setTimeout(() => {
        this.submitButtonLoading = false;
        window.location.href = process.env.VUE_APP_API_URL;
      }, 2000)
    }
  }
}
</script>
<style>
.el-dialog__footer {
  text-align: center;
}
.el-divider-horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 12px 0;
}
.upload-left {
  text-align: left;
}

.register-wrapper-div {
  padding-top: 10px;
  width: 750px;
  margin: 0 auto;
  background-color: #f8f8f8;
}
.el-dialog__body {
  padding: 10px 20px;
}
.el-radio {
  margin-right: 0;
}
.el-checkbox {
  margin-right: 5px;
}
.el-radio--mini.is-bordered {
  margin: 2px 0;
}
.el-divider--horizontal {
  margin: 10px 0;
}
.el-collapse-item__content {
  padding-bottom: 10px;
}
.el-alert--info.is-light {
  width: auto;
  height: 65%;
  margin-right: 15px;
}
.el-tag--plain {
  width: 130px;
  text-align: center;
  border: 0px solid #fff;
}
.radio-br {
  width: 75%;
}
.radio-auto {
  float: left;
  margin-right: 10px;
}
.assess-score {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Member/ConcernedAbout.vue